import gql from 'graphql-tag';

const GET_CALL_ATTEMPTS = gql`
  query getCallAttempts ($startTime:String, $endTime:String, $appDomain:String) {
    getCallAttempts(startTime:$startTime, endTime:$endTime, appDomain:$appDomain) {
      key,
      CallSummary {
        buckets {
          key_as_string,
          key,
          SumCallAttempts {
            value
          }
        }
      }
    }
  }
`;

const GET_OUTBOUND_CALLS = gql`
  query getOutboundCalls ($startTime:String, $endTime:String, $appDomain:String) {
    getOutboundCalls(startTime:$startTime, endTime:$endTime, appDomain:$appDomain) {
      key,
      CallSummary {
        buckets {
          key_as_string,
          key,
          SumCallAttempts {
            value
          },
          SumCallsAnsNoStats {
            value
          },
          SumCallsFailed {
            value
          },
          SumCallErrors {
            value
          },
          SumCallsAnsAudio {
            value
          },
          SumUnAnsCalls {
            value
          },
          SumCallsAnsNoAudio {
            value
          },
          SumCallsInternational {
            value
          },
          SumCallsBlocked {
            value
          }
        }
      }
    }
  }
`;

const GET_INBOUND_CALLS = gql`
  query getInboundCalls ($startTime:String, $endTime:String, $appDomain:String) {
    getInboundCalls(startTime:$startTime, endTime:$endTime, appDomain:$appDomain) {
      key,
      CallSummary {
        buckets {
          key_as_string,
          key,
          SumCallAttempts {
            value
          },
          SumCallsAnsNoStats {
            value
          },
          SumCallsFailed {
            value
          },
          SumCallErrors {
            value
          },
          SumCallsAnsAudio {
            value
          },
          SumUnAnsCalls {
            value
          },
          SumCallsAnsNoAudio {
            value
          }
        }
      }
    }
  }
`;

const GET_ONNET_CALLS = gql`
  query getOnNetCalls ($startTime:String, $endTime:String, $appDomain:String) {
    getOnNetCalls(startTime:$startTime, endTime:$endTime, appDomain:$appDomain) {
      key,
      CallSummary {
        buckets {
          key_as_string,
          key,
          SumCallAttempts {
            value
          },
          SumCallsAnsNoStats {
            value
          },
          SumCallsFailed {
            value
          },
          SumCallErrors {
            value
          },
          SumCallsAnsAudio {
            value
          },
          SumUnAnsCalls {
            value
          },
          SumCallsAnsNoAudio {
            value
          }
        }
      }
    }
  }
`;
const GET_HIGH_RISK_CALLS = gql`
  query getHighRiskCalls ($startTime:String, $endTime:String, $appDomain:String) {
    getHighRiskCalls(startTime:$startTime, endTime:$endTime, appDomain:$appDomain) {
      key,
      CallSummary {
        buckets {
          key_as_string,
          key,
          SumHighRiskCounts {
            value
          }
        }
      }
    }
  }
`;
export {
  GET_CALL_ATTEMPTS, GET_OUTBOUND_CALLS, GET_INBOUND_CALLS, GET_ONNET_CALLS, GET_HIGH_RISK_CALLS,
};
